if (!customElements.get('product-showcase-drawer')) {
  class ProductShowcaseDrawer extends HTMLElement {
    constructor() {
      super();
      this.overlay = null;
      this.trigger = null;
    }

    connectedCallback() {
      const drawerId = this.id;
      this.overlay = document.getElementById(`${drawerId}-overlay`);
      this.trigger = document.querySelector(`[data-drawer-trigger="${drawerId}"]`);

      this.#bindEvents();
    }

    #bindEvents() {
      const closeBtn = this.querySelector('[data-drawer-close]');

      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.open());
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) {
          this.close();
        }
      });
    }

    open() {
      this.setAttribute('open', '');
      if (this.overlay) {
        this.overlay.setAttribute('open', '');
      }
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
      }
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.removeAttribute('open');
      if (this.overlay) {
        this.overlay.removeAttribute('open');
      }
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
      }
      document.body.style.overflow = '';
    }
  }

  customElements.define('product-showcase-drawer', ProductShowcaseDrawer);
}
